module.exports = __webpack_public_path__ + "mainassets/img/graf2.d6cd96e4.svg";